import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha';
import { CommonSharedModule } from '../../../shared/shared.module';

const routes: Routes = [
  { path: '', component: ContactUsComponent },
]


@NgModule({
  declarations: [ContactUsComponent,],
  imports: [
    CommonModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    CommonSharedModule,
    RouterModule.forChild(routes)
  ]
})
export class ContactModule { }
